module.exports = __webpack_public_path__ + "img/index_5_img.97ac3c02.png";